import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/purchase-invoices/:purchaseInvoiceId/items/`;
const pathById = `${pathBase}:purchaseInvoiceItemId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const items = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
};
